const BASE = process.env.REACT_APP_API_URL || '/api';

// Il cookie di sessione deve viaggiare con ogni chiamata. In produzione
// frontend e API stanno sullo stesso indirizzo, quindi 'same-origin' basta.
const CREDENZIALI = 'same-origin';

// Quando la sessione scade, il server risponde 401 a tutto. Invece di lasciare
// l'interfaccia piena di errori, avvisiamo una volta sola: LoginGate ascolta
// e rimette la schermata di accesso.
function sessioneScaduta() {
  window.dispatchEvent(new CustomEvent('psa:sessione-scaduta'));
}

async function chiedi(path, opzioni = {}) {
  const res = await fetch(`${BASE}${path}`, { credentials: CREDENZIALI, ...opzioni });
  if (res.status === 401) {
    sessioneScaduta();
    throw new Error('Sessione non valida');
  }
  if (!res.ok) throw new Error(`API error ${res.status}: ${await res.text()}`);
  return res.json();
}

async function get(path) {
  return chiedi(path);
}

async function post(path, body) {
  return chiedi(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

async function del(path) {
  return chiedi(path, { method: 'DELETE' });
}

// Le chiamate di accesso non devono far scattare 'sessione scaduta': un 401
// qui vuol dire soltanto "password sbagliata".
async function postAccesso(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    credentials: CREDENZIALI,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const dati = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(dati.detail || `Errore ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return dati;
}

// helper: aggiunge ?market=XXX se fornito
const mk = (market) => market ? `market=${encodeURIComponent(market)}` : '';
const join = (...parts) => {
  const q = parts.filter(Boolean).join('&');
  return q ? `?${q}` : '';
};

export const api = {
  auth: {
    me:     ()          => fetch(`${BASE}/auth/me`, { credentials: CREDENZIALI }).then(r => r.json()),
    login:  (password)  => postAccesso('/auth/login', { password }),
    logout: ()          => postAccesso('/auth/logout', {}),
  },
  markets:    ()                     => get('/market/markets'),
  tickers:    ()                     => get('/market/tickers'),
  search:     (q)                    => get(`/market/search?q=${encodeURIComponent(q)}`),
  hotStocks:  (limit=25)             => get(`/screener/hot?limit=${limit}`),
  quote:      (t, market)            => get(`/market/quote/${t}${join(mk(market))}`),
  history:    (t, period, market)    => get(`/market/history/${t}${join(`period=${period}`, mk(market))}`),
  financials: (t, market)            => get(`/market/financials/${t}${join(mk(market))}`),
  technical:  (t, market, tf='daily')=> get(`/analysis/technical/${t}${join(mk(market), `timeframe=${tf}`)}`),
  insights:   (t, market)            => get(`/analysis/insights/${t}${join(mk(market))}`),
  earnings:   (t, market)            => get(`/market/earnings/${t}${join(mk(market))}`),
  news:       (t, name='', market)   => get(`/news/ticker/${t}${join(`company_name=${encodeURIComponent(name)}`, mk(market))}`),
  watchlist:  {
    get:    ()                       => get('/watchlist'),
    add:    (item)                   => post('/watchlist', item),
    remove: (market, ticker)         => del(`/watchlist?ticker=${encodeURIComponent(ticker)}&market=${encodeURIComponent(market)}`),
    import: (items)                  => post('/watchlist/import', { items }),
  },
  alerts: {
    get:    ()                       => get('/alerts'),
    add:    (a)                      => post('/alerts', a),
    remove: (id)                     => del(`/alerts?id=${encodeURIComponent(id)}`),
    check:  ()                       => get('/alerts/check'),
  },
};
